"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondsSincePastDate = exports.daysSincePastDate = exports.daysLeftToFutureDate = exports.findNextFridayInWeeks = exports.getTodayPlusDays = exports.getTodayPastDays = exports.getToday = exports.getNow = exports.sortDatesFunction = exports.sortDates = exports.deduplicatedDates = exports.isWithinSameMinute = exports.sortValueForDates = exports.daysBetweenDates = exports.ensureNotFutureDate = exports.getLeastRecentDate = exports.isSameDate = exports.isFutureDate = exports.minutesLeftToDate = exports.isWeekendDate = exports.isValidDate = exports.compareDatesForSorting = exports.compareDates = void 0;
const moment_1 = __importDefault(require("moment"));
const compareDates = (baseDate, targetDate) => {
    return moment_1.default.utc(baseDate).isBefore(targetDate) ? -1 : 1;
};
exports.compareDates = compareDates;
const compareDatesForSorting = (baseDate, compareDate, direction) => {
    if (direction === 'most-recent') {
        return (0, moment_1.default)(baseDate).isBefore(compareDate) ? 1 : -1;
    }
    return (0, moment_1.default)(baseDate).isBefore(compareDate) ? -1 : 1;
};
exports.compareDatesForSorting = compareDatesForSorting;
const isValidDate = (date) => {
    return !!date && moment_1.default.utc(date).isValid();
};
exports.isValidDate = isValidDate;
const isWeekendDate = (date) => {
    const dayIndex = moment_1.default.utc(date).day();
    return dayIndex === 6 || dayIndex === 0;
};
exports.isWeekendDate = isWeekendDate;
const minutesLeftToDate = (expirationDate) => {
    return moment_1.default.utc(expirationDate).diff(moment_1.default.utc(new Date()), 'minutes');
};
exports.minutesLeftToDate = minutesLeftToDate;
const isFutureDate = (date) => {
    return moment_1.default.utc(date).isAfter(moment_1.default.utc(new Date()));
};
exports.isFutureDate = isFutureDate;
const isSameDate = (baseDate, targetDate, unitOfTime) => {
    return moment_1.default.utc(baseDate).isSame(targetDate, unitOfTime);
};
exports.isSameDate = isSameDate;
const getLeastRecentDate = (baseDate, targetDate) => {
    return moment_1.default.utc(baseDate).isBefore(targetDate) ? baseDate : targetDate;
};
exports.getLeastRecentDate = getLeastRecentDate;
const ensureNotFutureDate = (date) => {
    if ((0, exports.isFutureDate)(date)) {
        return moment_1.default.utc().toDate();
    }
    return date;
};
exports.ensureNotFutureDate = ensureNotFutureDate;
const daysBetweenDates = (startDate, endDate) => {
    return Math.abs(moment_1.default.utc(startDate).diff(moment_1.default.utc(endDate), 'days'));
};
exports.daysBetweenDates = daysBetweenDates;
const sortValueForDates = (a, b) => {
    return moment_1.default.utc(a).isAfter(moment_1.default.utc(b)) ? 1 : -1;
};
exports.sortValueForDates = sortValueForDates;
const isWithinSameMinute = (baseDate, targetDate) => {
    return Math.abs(moment_1.default.utc(baseDate).diff(targetDate, 'minutes')) <= 1;
};
exports.isWithinSameMinute = isWithinSameMinute;
const deduplicatedDates = (dates) => {
    return dates.filter((date, index, array) => array.findIndex((val) => date == val) == index);
};
exports.deduplicatedDates = deduplicatedDates;
const sortDates = (dates, direction = 'most-recent') => {
    return dates.sort((a, b) => (0, exports.compareDatesForSorting)(a, b, direction)).map((date) => moment_1.default.utc(date).toDate());
};
exports.sortDates = sortDates;
const sortDatesFunction = (baseDate, compareDate, direction = 'least-recent') => {
    if (baseDate) {
        return 1;
    }
    if (compareDate) {
        return -1;
    }
    if (direction === 'most-recent') {
        return (0, moment_1.default)(baseDate).isBefore(compareDate) ? 1 : -1;
    }
    return (0, moment_1.default)(baseDate).isBefore(compareDate) ? -1 : 1;
};
exports.sortDatesFunction = sortDatesFunction;
const getNow = () => {
    return moment_1.default.utc().toDate();
};
exports.getNow = getNow;
const getToday = () => {
    return moment_1.default.utc().startOf('day').toDate();
};
exports.getToday = getToday;
const getTodayPastDays = (dayCount) => {
    return moment_1.default.utc().startOf('day').subtract(dayCount, 'days').toDate();
};
exports.getTodayPastDays = getTodayPastDays;
const getTodayPlusDays = (dayCount) => {
    return moment_1.default.utc().startOf('day').add(dayCount, 'days').toDate();
};
exports.getTodayPlusDays = getTodayPlusDays;
const findNextFridayInWeeks = (weeksLookup) => {
    const FridayIndex = 5;
    return moment_1.default.utc().add(weeksLookup, 'weeks').isoWeekday(FridayIndex).toDate();
};
exports.findNextFridayInWeeks = findNextFridayInWeeks;
const daysLeftToFutureDate = (date) => {
    return moment_1.default.utc(date).endOf('day').diff(moment_1.default.utc(new Date()), 'days');
};
exports.daysLeftToFutureDate = daysLeftToFutureDate;
const daysSincePastDate = (date) => {
    return moment_1.default.utc(new Date()).diff(date, 'days') || 0;
};
exports.daysSincePastDate = daysSincePastDate;
const secondsSincePastDate = (date) => {
    return moment_1.default.utc(new Date()).diff(date, 'seconds') || 0;
};
exports.secondsSincePastDate = secondsSincePastDate;
